import api from './api';

/**
 * Servicio para gestionar roles
 */
export const rolesService = {
  /**
   * Obtener todos los roles
   * @param {boolean} soloActivos - Solo roles activos (por defecto: true)
   */
  getAll: async (soloActivos = true) => {
    const params = {};
    if (soloActivos !== null) params.soloActivos = soloActivos;
    const response = await api.get('/roles', { params });
    return response;
  },

  /**
   * Obtener un rol por ID
   * @param {number} id - ID del rol
   */
  getById: async (id) => {
    const response = await api.get(`/roles/${id}`);
    return response;
  },

  /**
   * Crear un nuevo rol
   * @param {object} rol - Datos del rol
   */
  create: async (rol) => {
    const response = await api.post('/roles', rol);
    return response;
  },

  /**
   * Actualizar un rol
   * @param {number} id - ID del rol
   * @param {object} rol - Datos actualizados del rol
   */
  update: async (id, rol) => {
    const response = await api.put(`/roles/${id}`, rol);
    return response;
  },

  /**
   * Desactivar un rol (baja lógica)
   * @param {number} id - ID del rol
   */
  delete: async (id) => {
    const response = await api.delete(`/roles/${id}`);
    return response;
  },

  /**
   * Asignar permisos a un rol
   * @param {number} id - ID del rol
   * @param {array} permisoIDs - Lista de IDs de permisos
   */
  asignarPermisos: async (id, permisoIDs) => {
    const response = await api.post(`/roles/${id}/permisos`, {
      PermisoIDs: permisoIDs,
    });
    return response;
  },
};

